export const getFormattedPhone = (phone: string) => {
  // para telefones comuns, xxxx-xxxx ou xxxxx-xxxx
  if (phone.length === 8 || phone.length === 9) {
    return phone.substring(0, phone.length - 4) + '-' + phone.substring(phone.length - 4);
  }
  // para celulares com ddd (xx) xxxxx-xxxx
  if (phone.length === 11) {
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
  }
  return phone;
};
